module.exports = __webpack_public_path__ + "static/media/forward.5bb9e10f.svg";